/**
 * DED-1332: Table Column Display Configuration
 * 
 * This file contains configuration for hiding internal fields and renaming columns
 * in the DataTable "Manage Columns" dropdown across different tables.
 */

import { ColumnDisplayConfig } from '@/components/ui/datatable';

/**
 * Assurance Tasks table configuration
 * Note: Column keys use dot notation to match accessorKey in column definitions
 */
export const assuranceTasksColumnConfig: ColumnDisplayConfig = {
  hiddenColumns: [
    'assId',
    'assID',
    'componentId',
    'specialType',
    'rawData',
    'isChecklistTask',
    'checkDetail',
    'checkFrequency',
    'checkHistory',
    'history',
  ],
  columnRenames: {
    'checkDetail.check': 'Assurance Task',
    'checkDetail.assignedTo': 'Assigned To',
    'checkFrequency.nextCheck': 'Next Check',
    'checkDetail.framework': "Framework"
  },
};

/**
 * Checklists table configuration
 */
export const checklistsColumnConfig: ColumnDisplayConfig = {
  hiddenColumns: [
    'cacheCreatedOn',
    'cacheUpdatedOn',
    'isAssuranceTask',
    'templateId',
    'signature',
    'repeat',
    'badgeClass',
    'isReusable',
    'tenantId',
    'items',
    'completedAt',
    'status',
    'cacheContentHash',
    'completionHistory',
    'standards',
  ],
  columnRenames: {},
};

/**
 * Audits table configuration (Audit Centre)
 */
export const auditsColumnConfig: ColumnDisplayConfig = {
  hiddenColumns: [
    'incidents',
  ],
  columnRenames: {},
};

/**
 * Findings table configuration (Audit Centre)
 */
export const findingsColumnConfig: ColumnDisplayConfig = {
  hiddenColumns: [
    'auditId',
    'origin',
    'comments',
  ],
  columnRenames: {},
};

/**
 * Incidents Register table configuration
 */
export const incidentsColumnConfig: ColumnDisplayConfig = {
  hiddenColumns: [
    'auditId',
  ],
  columnRenames: {},
};

/**
 * Corrective Actions table configuration (Audit Centre)
 */
export const correctiveActionsColumnConfig: ColumnDisplayConfig = {
  hiddenColumns: [
    'auditId',
  ],
  columnRenames: {},
};

/**
 * Asset Register table configuration
 */
export const assetRegisterColumnConfig: ColumnDisplayConfig = {
  hiddenColumns: [
    'assetTeam',
    'assetHistory',
  ],
  columnRenames: {},
};

/**
 * Risk Register table configuration
 * Note: Column keys should match actual accessorKey values
 * Based on DED-1332 Comment #5 requirements from Ahmed:
 * - Remove 'Related Controls' (use selectedControls renamed instead)
 * - Remove 'Cons Type'
 * - Remove 'Cache Content Hash'
 * - Remove 'Cache Created On'
 * - Remove 'Cache Updated On'
 * - Remove 'Risk I DRating'
 * - Rename 'Selected Controls' to 'Related Controls'
 * - Rename 'Risk Like' to 'Risk Likelihood'
 */
export const riskRegisterColumnConfig: ColumnDisplayConfig = {
  hiddenColumns: [
    // From Ahmed's list in Comment #5
    'relatedControls',
    'consType',
    // Both camelCase and snake_case variants for cache fields
    'cacheContentHash',
    'cacheCreatedOn',
    'cacheUpdatedOn',
    'cache_content_hash',
    'cache_created_on',
    'cache_updated_on',
    'riskIDRating',
    // Internal/technical fields that shouldn't be user-facing
    'componentId',
    'history',
    'riskHistory',
    'version',
  ],
  columnRenames: {
    'selectedControls': 'Related Controls',
    'riskLike': 'Risk Likelihood',
    'riskIDstatus': 'Risk ID Status',
  },
};

/**
 * Data Register table configuration
 */
export const dataRegisterColumnConfig: ColumnDisplayConfig = {
  hiddenColumns: [
    'assets',
    'suppliers',
    'dataRetentionPeriodUnit',
    'dataTypeModeOfCollection',
  ],
  columnRenames: {},
};

/**
 * Document Library table configuration
 */
export const documentLibraryColumnConfig: ColumnDisplayConfig = {
  hiddenColumns: [
    'msgTables',
    'updateMethod',
    'originalData',
    'history',
    'docId',
  ],
  columnRenames: {},
};
